export const formatAuditJson = (value: Record<string, unknown> | null | undefined) => {
  if (!value) {
    return '(none)';
  }
  return JSON.stringify(value, null, 2);
};
